module.exports = __webpack_public_path__ + "components/flag/static/square/om-8cf5a96cde11baf0d96eba5d2c1286c2.svg";